(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whatsapp"] && !Shopify.designMode) return;
  try {
    const DISMISS_KEY = 'saltare:whatsapp-notice-dismissed-until';
  const SESSION_KEY = 'saltare:whatsapp-notice-session';
  const SESSION_START_KEY = 'saltare:whatsapp-notice-session-start';
  const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
  const ATTENTION_DELAY = 30000;

  const canShowNotice = () => {
    try {
      const dismissedUntil = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (dismissedUntil && Date.now() < dismissedUntil) return false;
      return sessionStorage.getItem(SESSION_KEY) !== 'closed';
    } catch (error) {
      return true;
    }
  };

  const noticeAlreadyShown = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === 'shown';
    } catch (error) {
      return false;
    }
  };

  const remainingAttentionDelay = () => {
    try {
      const startedAt = Number(sessionStorage.getItem(SESSION_START_KEY) || 0);
      const now = Date.now();
      if (!startedAt) {
        sessionStorage.setItem(SESSION_START_KEY, String(now));
        return ATTENTION_DELAY;
      }
      return Math.max(0, ATTENTION_DELAY - (now - startedAt));
    } catch (error) {
      return ATTENTION_DELAY;
    }
  };

  const markSessionShown = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, 'shown');
    } catch (error) {}
  };

  const dismissNotice = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, 'closed');
      localStorage.setItem(DISMISS_KEY, String(Date.now() + SEVEN_DAYS));
    } catch (error) {}
  };

  const wiggleButton = (button) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    button.classList.remove('is-wiggle');
    void button.offsetWidth;
    button.classList.add('is-wiggle');
  };

  const revealNotice = (notice) => {
    if (!notice || !canShowNotice()) return;
    notice.hidden = false;
    markSessionShown();
  };

  document.querySelectorAll('[data-whatsapp-float]').forEach((root) => {
    const notice = root.querySelector('[data-whatsapp-notice]');
    const closeButton = root.querySelector('[data-whatsapp-notice-close]');
    const button = root.querySelector('[data-whatsapp-button]');
    const noticeDelay = remainingAttentionDelay();

    if (notice && canShowNotice()) {
      if (noticeAlreadyShown()) {
        revealNotice(notice);
      } else {
        window.setTimeout(() => revealNotice(notice), noticeDelay);
      }
    }

    closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (notice) notice.hidden = true;
      dismissNotice();
    });

    if (button) {
      window.setTimeout(() => {
        wiggleButton(button);
        window.setInterval(() => wiggleButton(button), ATTENTION_DELAY);
      }, ATTENTION_DELAY);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
